import styled from 'styled-components'

export const FadeInDiv = styled.div`
  opacity: ${({ opacity }) => opacity};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: ${({ alignItems }) => alignItems};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: opacity 0.5s;
`

export const Icon = styled.img`
  width: ${({ width }) => width};
  transition: width 0.5s, margin 0.5s;
`

export const UserProfilePictureHolder = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
`
export const UserProfilePicture = styled.img`
  width: 52px;
`

export const ColumnFlexDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: ${({ alignItems }) => alignItems};
  width: ${({ width }) => width};
  height: ${({ height }) => (height ? height : 'max-content')};
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
`

export const RowFlexDiv = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  display: flex;
  flex-direction: row;
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: ${({ alignItems }) => alignItems};
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
  transition: width 0.5s, opacity 0.5s;
`

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 18px 0 18px 0;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  position: fixed;
  z-index: 200;
  width: 99px;
  transition: width 0.5s;
  height: 100vh;
  padding: 2vh 0 4vh 0;
  box-sizing: border-box;

  background-image: linear-gradient(to bottom, #6f03fd, #9839ca);

  box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.32);
  -webkit-box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.32);

  :hover {
    width: 232px;
  }
`
